(() => {
  if (window.__fenzaHeaderLogoReady) return;
  window.__fenzaHeaderLogoReady = true;

  const scrollKey = 'fenza-home-logo-scroll-top';

  const normalizePath = (path) => {
    const normalized = path.replace(/\/+$/, '');
    return normalized || '/';
  };

  const scrollHomeToTop = () => {
    const pageWrapper = document.querySelector('.page-wrapper');
    if (pageWrapper) pageWrapper.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  };

  const restoreRequestedHomePosition = () => {
    let requested = false;
    try {
      requested = sessionStorage.getItem(scrollKey) === 'true';
    } catch (_error) {
      requested = new URLSearchParams(window.location.search).has('fenza_home_top');
    }
    if (!requested) return;

    const logo = document.querySelector('[data-fenza-home-logo]');
    if (!logo) return;
    const homePath = normalizePath(new URL(logo.dataset.homeUrl || logo.href, window.location.origin).pathname);
    if (normalizePath(window.location.pathname) !== homePath) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    scrollHomeToTop();
    requestAnimationFrame(scrollHomeToTop);
    window.setTimeout(scrollHomeToTop, 80);
    window.setTimeout(() => {
      scrollHomeToTop();
      try {
        sessionStorage.removeItem(scrollKey);
      } catch (_error) {
        // The query-string fallback below still guarantees the top position.
      }
      const url = new URL(window.location.href);
      if (url.searchParams.has('fenza_home_top')) {
        url.searchParams.delete('fenza_home_top');
        history.replaceState(history.state, '', `${url.pathname}${url.search}${url.hash}`);
      }
    }, 220);
  };

  document.addEventListener(
    'click',
    (event) => {
      const logo = event.target.closest?.('[data-fenza-home-logo]');
      if (!logo || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();
      const homeUrl = new URL(logo.dataset.homeUrl || logo.href, window.location.origin);
      try {
        sessionStorage.setItem(scrollKey, 'true');
      } catch (_error) {
        homeUrl.searchParams.set('fenza_home_top', '1');
      }

      if (normalizePath(window.location.pathname) === normalizePath(homeUrl.pathname)) {
        history.replaceState(history.state, '', `${homeUrl.pathname}${homeUrl.search}${homeUrl.hash}`);
        scrollHomeToTop();
        try {
          sessionStorage.removeItem(scrollKey);
        } catch (_error) {
          // No persistent marker is required when already on the home page.
        }
        return;
      }

      window.location.assign(homeUrl.href);
    },
    true
  );

  restoreRequestedHomePosition();
  window.addEventListener('pageshow', restoreRequestedHomePosition);
})();
